var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.994 14a1 1 0 0 0 .606-1.8A3.98 3.98 0 0 1 14 9V6A5.999 5.999 0 1 0 2.006 6v3c0 1.26-.594 2.447-1.605 3.2A1 1 0 0 0 1 14h4.998a2 2 0 1 0 3.998 0zm-2.828-7.995v3c0 1.057.29 2.095.835 3H3.005a5.8 5.8 0 0 0 .833-3v-3a4.168 4.168 0 0 1 8.329 0",
    clipRule: "evenodd"
  })));
};
export default SvgBell;